const Orange = {
  Orange: {
    _000: '#FFF7ED',
    _100: '#FFEDD5',
    _200: '#FED7AA',
    _300: '#FDBA74',
    _400: '#FB923C',
    _500: '#F97316',
    _600: '#EA580C',
    _700: '#C2410C',
    _800: '#9A3412',
    _900: '#7C2D12',
  },
};

export default Orange;
